import { render, staticRenderFns } from "./CustomerSupportUserIcon.vue?vue&type=template&id=37e0311b&scoped=true"
import script from "./CustomerSupportUserIcon.vue?vue&type=script&lang=js"
export * from "./CustomerSupportUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0311b",
  null
  
)

export default component.exports